import axios from "axios";

export const checkPrivileges = async (maker, groupIdsOfUser, api, headers) => {
  if (!maker) return false;

  try {
    const response = await axios.get(
      `${api}/user/getgroupid?email=${maker}`,
      headers
    );
    const makerGroupIds = response.data || [];
    const match = makerGroupIds.some((id) => groupIdsOfUser.includes(id));
    if (match) return true;
    return false;
  } catch (error) {
    console.error("Error checking permissions:", error);
    return false;
  }
};
